export default __webpack_public_path__ + "static/B0020-e64b722010ba26ee840464c1d8c8f138.png";